import React from 'react'
import styled from 'styled-components'
import { rem } from 'polished'
import BodyText from 'LuxKit/Typography/BodyText'
import Heading from 'LuxKit/Typography/Heading'
import TextButton from 'LuxKit/Button/TextButton'
import LineExclamationCircleIcon from 'LuxKit/Icons/line/LineExclamationCircleIcon'
import Group from 'components/utils/Group'

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  padding: ${rem(24)};
  text-align: center;
  background-color: ${props => props.theme.palette.neutral.default.one};
`

const IconContainer = styled.div`
  color: ${props => props.theme.palette.messaging.critical.normalForeground};
`

interface Props {
  error?: Error
  onRetry?: () => void
  onClose?: () => void
}

function WrappedErrorState({ error, onRetry, onClose }: Props) {
  const isNotFound = error && 'status' in error && error.status === 404

  return (
    <Container>
      <Group direction="vertical" gap={24} horizontalAlign="center">
        <IconContainer>
          <LineExclamationCircleIcon size={48} />
        </IconContainer>
        <Group direction="vertical" gap={8} horizontalAlign="center">
          <Heading variant="heading4">
            {isNotFound ? 'Wrapped not found' : 'Something went wrong'}
          </Heading>
          <BodyText variant="medium" colour="neutral-two">
            {isNotFound
              ? 'This Wrapped link may have expired or is no longer available.'
              : 'We couldn\'t load your year in review. Please try again.'}
          </BodyText>
        </Group>
        <Group direction="horizontal" gap={12}>
          {onRetry && !isNotFound && (
            <TextButton kind="primary" onClick={onRetry}>
              Try again
            </TextButton>
          )}
          {onClose && (
            <TextButton kind="secondary" onClick={onClose}>
              Close
            </TextButton>
          )}
        </Group>
      </Group>
    </Container>
  )
}

export default WrappedErrorState
